/* eslint-disable no-nested-ternary */
import React, { useMemo, useContext, useEffect } from 'react';
import loadable from '@loadable/component';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
// import Animation from 'ls-common-client/dist/components/Animation';
// import profileLoader from '../../animations/profileLoader.json';
import AddABusiness from '../../components/AddABusiness';
import ReviewForm from '../../components/ReviewForm';
import ScrollToTop from '../../components/ScrollToTop';
import HoverIcon from '../../components/HoverIcon';
import { Context } from '../../context/AppContext';
import getFullStateName from '../../utils/getFullStateName';
import findUrl from '../../utils/findUrl';
// import useSsr from '../../hooks/useSsr';
import useContextApi from '../../hooks/useContextApiSpeed';
import Meta from './Meta';
import BusinessList from './BusinessList';
import Top from '../../components/Landing/Top';
import ArcBackground from '../../components/Landing/Background/Arc';
import LazyLoad from '../../components/LazyLoad';
import UrlList from '../../components/Landing/UrlList';
import About from '../../components/Landing/About';
import ReadMore from '../../components/Landing/About/ReadMore';
import BreadcrumbsBottom from '../../components/Landing/BreadcrumbsBottom';
import redirects from './redirects';
import PopularIndustries from '../../components/Landing/PopularIndustries';
import {
  // searchSeoSuburbQuery,
  searchSuggestSuburbsQuery,
} from '../../gql/search';
import NextLink from '../../components/NextLink';
import SearchAreaSuggestQuery from '../../components/Search/common/hooks/useSearchAreaSuggest/SearchAreaSuggestQuery';
import NotFound from '../NotFound';

const QuoteEnquiries = loadable(() =>
  import('../../components/Landing/QuoteEnquiries')
);
const FeatureReviews = loadable(() =>
  import('../../components/Landing/FeatureReviews')
);
const AppDownload = loadable(() =>
  import('../../components/Landing/AppDownload')
);
const LocalBusinessInfo = loadable(() =>
  import('../../components/Landing/LocalBusinessInfo')
);
const TopRatedBusinesses = loadable(() =>
  import('../../components/Landing/TopRatedBusinesses')
);
const B2bSection = loadable(() => import('../../components/B2bSection'));
const LifestyleBlogs = loadable(() =>
  import('../../components/Blogs/Lifestyle')
);
const PopularCategories = loadable(() =>
  import('../../components/Landing/PopularCategories')
);
const ListYourBusiness = loadable(() =>
  import('../../components/Landing/ListYourBusiness')
);
const DigitalMarketingBanner = loadable(() =>
  import('../../components/DigitalMarketingBanner')
);
const PopularRegions = loadable(() =>
  import('../../components/Landing/PopularRegions')
);

const StyledRoot = styled(Container)`
  background: #ffffff;
`;

// const ssr = ({ params, redirect, pathname }) => {
//   const { state: paramState, suburb: paramSuburb } = params;

//   return [
//     {
//       name: 'SeoSuburb',
//       query: searchSeoSuburbQuery,
//       variables: {
//         params: {
//           suburb: paramSuburb,
//           state: paramState,
//         },
//       },
//       callback: (data, errors) => {
//         const url = redirects({ params, data, pathname, errors });
//         return url ? redirect(url) : false;
//       },
//     },
//   ];
// };

const ssr = ({ params, redirect, pathname }) => {
  const { state: paramState, suburb: paramSuburb } = params;

  return [
    {
      api: 'SeoSuburb',
      options: {
        params: {
          suburb: paramSuburb,
          state: paramState,
        },
      },
      callback: (data, errors) => {
        const url = redirects({ params, data, pathname, errors });
        return url ? redirect(url) : false;
      },
    },
  ];
};

const Suburb = ({ match }) => {
  const { params } = match || {};
  const { state: paramState, suburb: paramSuburb } = params;
  const {
    userLocation: { setLocation, location },
    media: { mobile, tablet },
  } = useContext(Context);
  const { data: searchAreaData } = useQuery(SearchAreaSuggestQuery, {
    variables: {
      query: `${paramSuburb} ${paramState}`,
      first: 1,
      enabled: true,
    },
  });

  const initialSA = searchAreaData?.searchAreaSuggest?.edges?.[0]?.node;

  const initialSearchArea = initialSA
    ? {
        id: initialSA.id,
        path: initialSA.path,
        label: initialSA.description,
        shortLabel: initialSA.name,
        statisticalAreas: initialSA.statisticalAreas,
      }
    : undefined;

  // const { SeoSuburb, redirectUrl } = useSsr(ssr);  # REVERT GRAPHQL
  const { SeoSuburb } = useContextApi(ssr);

  const { data: SuggestSuburbsData, loading } = useQuery(
    searchSuggestSuburbsQuery,
    {
      variables: {
        params: {
          keyword: paramSuburb,
          state: paramState,
        },
      },
    }
  );

  // const { searchSeoSuburb } = SeoSuburb || {};  # REVERT GRAPHQL
  // const { data, links } = searchSeoSuburb || {};
  const { data, links } = SeoSuburb || {};
  const { attributes } = (data && data[0]) || {};
  const { breadcrumbs } = links || {};

  const { searchSuggestSuburbs } = SuggestSuburbsData || {};
  const { data: suburbData } = searchSuggestSuburbs || {};

  const {
    description,
    name,
    geolocation: geo,
    region,
    state,
    top_paid_businesses: topPaidBusinesses = [],
    popular_categories: popularCategories = [],
  } = attributes || {};
  const { url_name: locationSlug } = location || {};
  const fullStateName = useMemo(() => getFullStateName(state), [state]);

  useEffect(() => {
    if (suburbData && suburbData.length) {
      const suburbAttributes = suburbData.reduce((agg, item) => {
        if (item.suburbName === name && item.state === state) return item;
        return agg;
      }, {});
      if (suburbAttributes.id)
        setLocation({
          ...suburbAttributes,
          name: suburbAttributes.suburbName,
          url_name: suburbAttributes.urlSlug,
        });
    }
  }, [suburbData, name, state]);

  // if (redirectUrl)  # REVERT GRAPHQL
  //   return (
  //     <StyledRoot>
  //       <Container width="150px" margin="0 auto">
  //         <Animation data={profileLoader} width="150px" />
  //       </Container>
  //       <Redirect to={redirectUrl} />
  //     </StyledRoot>
  //   );

  if (!loading && (!name || !region)) {
    return <NotFound />;
  }

  return (
    <StyledRoot className="Suburb__root">
      <ScrollToTop />
      <Meta
        name={name}
        state={state}
        fullStateName={fullStateName}
        canonical={match.url}
        description={`Find top-rated hairdressers, plumbers, accountants, dentists, restaurants and more in ${name} on Localsearch.`}
      />
      <Top
        heading={
          <>
            <span>Find the businesses you need in</span>
            {name}, {region}
          </>
        }
        subHeading={fullStateName}
        searchProps={{ initialSearchArea }}
      />
      <ArcBackground>
        {popularCategories &&
          !!popularCategories.length &&
          popularCategories[0] &&
          popularCategories[0].categories &&
          !!popularCategories[0].categories.length && (
            <PopularIndustries
              title={`Popular industries in ${name}`}
              data={popularCategories[0].categories}
              locationSlug={locationSlug}
              shuffle
            />
          )}
        <About
          title={`The easy, quick way to find ${name} businesses, get quotes and more!`}
          description={description}
          geo={geo}
          location={name}
          state={state}
          address={`${name}, ${state} Australia`}
          zoom={10}
          b2bStyle={mobile ? 'vertical' : 'horizontal'}
        />
      </ArcBackground>
      <LazyLoad>
        {name && state && (
          <QuoteEnquiries
            params={{
              suburbName: name,
              state,
            }}
            name={name}
          />
        )}
      </LazyLoad>
      <LazyLoad
        className="Suburb__LocalBusinessInfo"
        style={{
          minHeight: mobile ? '712px' : tablet ? '574px' : '599px',
        }}
      >
        <LocalBusinessInfo
          title={`All the information you need
for ${name} businesses in one place.`}
          subTitle={`There are other ${name} locals searching for, reviewing and contacting businesses on Localsearch right now!
          See how people are engaging with them:`}
        />
      </LazyLoad>
      <LazyLoad>
        {name && state && (
          <FeatureReviews
            params={{
              suburbName: name,
              state,
            }}
            title={`Featured Reviews about Local Businesses in ${name}`}
          />
        )}
      </LazyLoad>
      {description && description.length > 745 ? (
        <ReadMore
          description={description}
          title={`Did you know this about ${name}?`}
        />
      ) : (
        ''
      )}
      <LazyLoad>
        <TopRatedBusinesses
          params={{ first: 4, suburbName: name, state }}
          hideSuburb
          title={`Top-rated ${name} businesses`}
          subTitle={`Checkout these popular businesses in ${name}`}
        />
      </LazyLoad>
      <LazyLoad
        className="Suburb__SeoTop"
        style={{
          minHeight: mobile ? '1692px' : tablet ? '1692px' : '1332px',
        }}
      >
        <AppDownload />
        <B2bSection />
      </LazyLoad>
      <LazyLoad>
        {topPaidBusinesses && !!topPaidBusinesses.length && (
          <TopRatedBusinesses
            data={topPaidBusinesses}
            limit={4}
            hideSuburb
            title={`Locals are talking of these ${name} businesses`}
            subTitle={`Check out these popular businesses in ${name}`}
          />
        )}
      </LazyLoad>
      {popularCategories &&
        !!popularCategories.length &&
        popularCategories[0] &&
        popularCategories[0].categories &&
        !!popularCategories[0].categories.length && (
          <UrlList
            className="Suburb__CategoryList"
            title={`Top 100 categories for ${name}`}
            subTitle="See the most popular categories locals are searching for."
            data={popularCategories[0].categories}
            columns={3}
            renderItem={item => (
              <HoverIcon>
                <NextLink
                  to={findUrl({
                    keyword: item.name,
                    suburb_url: locationSlug,
                  })}
                >
                  {item.name}
                </NextLink>
              </HoverIcon>
            )}
          />
        )}
      <LazyLoad
        className="Suburb__SeoBottom"
        style={{
          minHeight: mobile ? '4091px' : tablet ? '3473px' : '2701px',
        }}
      >
        <LifestyleBlogs
          style={{
            background: '#ffffff',
          }}
        />
        <PopularRegions />
        <ListYourBusiness
          title={`List your business in ${name}`}
          text={`${name} locals are just waiting to find your business on Localsearch. All it takes to add your business is completing the super quick and easy form—click the button below to go there now. What are you waiting for?`}
        />
        <PopularCategories
          locationSlug={locationSlug}
          title={`Discover businesses in the ${name} area`}
        />
      </LazyLoad>
      <BusinessList suburb={name} state={state} />
      <DigitalMarketingBanner />
      <BreadcrumbsBottom breadcrumbs={breadcrumbs} />
      <ReviewForm />
      <AddABusiness />
    </StyledRoot>
  );
};

export { ssr };

export default Suburb;
